module.exports = __webpack_public_path__ + "img/图片7.b8ad7833.png";